<script>
import { Line } from "vue-chartjs"

export default {
  extends: Line,
  props: ["chartData", "chartOptions"],
  mounted() {
    this.renderChart(this.chartData, this.chartOptions)
  }
}
</script>
